module.exports = __webpack_public_path__ + "img/CC-Logo.f80efb32.png";